import React, { useEffect, useState } from "react";
import BASE_URL from "../../config";

export default function Join() {
  const [contacts, setContacts] = useState([]);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    address: "",
  });
  const mapLinks = {
    1: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.2920519049176!2d72.8532818758886!3d21.220264480477343!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f0047a7f9e9%3A0x16b2773211832801!2sSatyam%20Shivam%20Sundaram!5e0!3m2!1sen!2sin!4v1779699566694!5m2!1sen!2sin",

    2: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.0642803406813!2d72.96819507588977!3d21.268922980441257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be047005f7f8511%3A0xed6bbd6a0811eaf7!2sAkruti%20Banglows%2C%20Papa%20Sitaram%20chowk%2C%20Canal%20road%2C%20Kamrej%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1779700235386!5m2!1sen!2sin",

    3: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29759.44774255046!2d72.78538401083982!3d21.194901100000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04e63dd931dcb%3A0xe6912c373e1b79e3!2sToran%20Apartment!5e0!3m2!1sen!2sin!4v1779700540375!5m2!1sen!2sin",
  };

  const directionLinks = {
    1: "https://www.google.com/maps/dir/?api=1&destination=21.220264480477343,72.8532818758886",

    2: "https://www.google.com/maps/dir/?api=1&destination=21.268922980441257,72.96819507588977",

    3: "https://www.google.com/maps/dir/?api=1&destination=Toran Apartment Katargam Surat",
  };
  // FETCH ALL CONTACTS
  useEffect(() => {
    const fetchContacts = () => {
      fetch(`${BASE_URL}/api/getContact.php?t=${Date.now()}`)
        .then((res) => res.json())
        .then((data) => setContacts(data));
    };

    fetchContacts();

    const interval = setInterval(fetchContacts, 3000);

    return () => clearInterval(interval);
  }, []);

  // INPUT CHANGE
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // SUBMIT
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();

    formData.append("name", form.name);
    formData.append("phone", form.phone);
    formData.append("address", form.address);

    fetch(`${BASE_URL}/api/saveJoin.php`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.text())
      .then((msg) => {
        alert(msg);

        setForm({
          name: "",
          phone: "",
          address: "",
        });
      });
  };

  // WHATSAPP
  const openWhatsApp = (phone) => {
    if (!phone) return;

    let cleanPhone = phone.toString().replace(/[^0-9]/g, "");

    // add India country code if missing
    if (cleanPhone.length === 10) {
      cleanPhone = "91" + cleanPhone;
    }

    const message = `Hello, I want to apply.\nName: ${form.name}\nPhone: ${form.phone}`;

    window.open(
      `https://wa.me/${cleanPhone}?text=${encodeURIComponent(message)}`,
      "_blank",
    );
  };
  return (
    <div className="join-page">
      <div className="trust-header1">
        <span className="trust-tag1">Contact US</span>

        <h2>સંપર્કમાં રહો</h2>

        <p>
          દરેક યોજનાની વિસ્તૃત માહિતી તેમજ સોસાયટીમાં શેર સભાપદ થવા માટે બહેનો
          ઓફિસે કાર્યાલયમાં મેનેજરશ્રી ને ઓફિસ સમય દરમિયાન રૂબરૂ મળો.
        </p>
      </div>

      {/* FIRST ROW */}
      <div className="top-row">
        <div className="join-form-wrapper">
          <h4 className="text-center">સંપર્ક કરો</h4>

          <form className="join-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>પૂરું નામ</label>

              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="તમારું નામ દાખલ કરો"
                required
              />
            </div>

            <div className="form-group">
              <label>મોબાઇલ નંબર</label>

              <input
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="મોબાઇલ નંબર"
                required
              />
            </div>

            <div className="form-group">
              <label>પ્રશ્ન</label>

              <textarea
                name="address"
                value={form.address}
                onChange={handleChange}
                placeholder="તમારો પ્રશ્ન"
                required
              ></textarea>
            </div>

            <button type="submit">અરજી કરો</button>
            <div
              className="whatsapp-contact"
              onClick={() => openWhatsApp(contacts[0].phone1)}
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/220/220236.png"
                alt="WhatsApp"
              />

              <span>WhatsApp</span>
            </div>
          </form>
        </div>
        {/* FIRST OFFICE CARD */}
        {contacts[0] && (
          <div className="office-card first-office">
            <div className="contact-heading">
              <h4>અમારી મુલાકાત લો</h4>
            </div>

            <h5>
              <i className="bi bi-geo-alt-fill"></i>
              {contacts[0].office_name}
            </h5>

            <p style={{ fontWeight: "550", paddingLeft: "50px" }}>
              {contacts[0].address}
            </p>
            <div className="row">
              <div className="col-md-12">
                <h5>
                  <i className="bi bi-telephone-fill"></i>
                  અમને કૉલ કરો
                </h5>

                <p style={{ fontWeight: "550", paddingLeft: "50px" }}>
                  {contacts[0].phone1}
                  {contacts[0].phone2 && ` / ${contacts[0].phone2}`}
                </p>
              </div>
              <div className="col-md-12">
                {" "}
                <h5>
                  <i className="bi bi-envelope-fill"></i>
                  અમને ઇમેઇલ કરો
                </h5>
                <p style={{ fontWeight: "550", paddingLeft: "50px" }}>
                  vaibhavlaxmi2009@yahoo.com
                </p>
              </div>
            </div>

            <h5>
              <i className="bi bi-clock-fill"></i>
              કામકાજ નો સમય
            </h5>

            <p style={{ fontWeight: "550", paddingLeft: "50px" }}>
              {contacts[0].timing}
            </p>

            <div
              className="map-container"
              onClick={() =>
                window.open(directionLinks[contacts[0].id], "_blank")
              }
              style={{ cursor: "pointer" }}
            >
              <iframe
                src={mapLinks[contacts[0].id]}
                width="600"
                height="450"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
              ></iframe>
            </div>
          </div>
        )}

        {/* CONTACT FORM */}
      </div>

      {/* SECOND ROW */}
      <div className="membership-title">
        <h2 className="text-center" style={{ marginBottom: "30px" }}>
          અમારી અન્ય શાખાઓ
        </h2>
      </div>

      <div className="office-grid second-row">
        {contacts.slice(1).map((contact) => (
          <div key={contact.id} className="office-card">
            <h5>
              <i className="bi bi-geo-alt-fill"></i>
              {contact.office_name}
            </h5>

            <p style={{ fontWeight: "550", paddingLeft: "50px" }}>
              {contact.address}
            </p>
            <div className="row">
              <div className="col-md-12">
                <h5>
                  <i className="bi bi-telephone-fill"></i>
                  અમને કૉલ કરો
                </h5>

                <p style={{ fontWeight: "550", paddingLeft: "50px" }}>
                  {contact.phone1}
                  {contact.phone2 && ` / ${contact.phone2}`}
                </p>
              </div>
              <div className="col-md-12">
                {" "}
                <h5>
                  <i className="bi bi-envelope-fill"></i>
                  અમને ઇમેઇલ કરો
                </h5>
                <p style={{ fontWeight: "550", paddingLeft: "50px" }}>
                  vaibhavlaxmi2009@yahoo.com
                </p>
              </div>
            </div>
            <h5>
              <i className="bi bi-clock-fill"></i>
              કામકાજ નો સમય
            </h5>

            <p style={{ fontWeight: "550", paddingLeft: "50px" }}>
              {contact.timing}
            </p>

            <div
              className="map-container"
              onClick={() => window.open(directionLinks[contact.id], "_blank")}
              style={{ cursor: "pointer" }}
            >
              <iframe
                src={mapLinks[contact.id]}
                width="600"
                height="450"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ border: 0 }}
              ></iframe>
            </div>

            <div
              className="whatsapp-contact"
              onClick={() => openWhatsApp(contact.phone1)}
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/220/220236.png"
                alt="WhatsApp"
              />

              <span>WhatsApp</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
